import ExpandLess from '@mui/icons-material/ExpandLess';
import { Fab, Zoom } from '@mui/material';
import { FC, useEffect, useState } from 'react';

const ScrollToTopButton: FC = () => {
    const [showButton, setShowButton] = useState(false);
    const [flexContainer, setFlexContainer] = useState<HTMLElement | null>(null);

    const handleScroll = () => {
        if (flexContainer && typeof window !== 'undefined') {
            const { scrollTop } = flexContainer;
            const scrollMin = 2 * window.innerHeight;

            setShowButton(scrollTop > scrollMin);
        }
    };

    const onClick = () => {
        (flexContainer as unknown as HTMLElement)?.scrollTo({ behavior: 'smooth', top: 0 });
    };

    useEffect(() => {
        setFlexContainer(
            typeof document !== 'undefined' ? document.getElementById('app-flex-container') : null,
        );
    }, []);

    useEffect(() => {
        flexContainer?.addEventListener('scroll', handleScroll, { passive: true });

        return () => flexContainer?.removeEventListener('scroll', handleScroll);
    });

    return (
        <Zoom in={showButton}>
            <Fab
                color="primary"
                onClick={onClick}
                sx={{ bottom: 32, boxShadow: 1, position: 'fixed', right: 32, zIndex: 'drawer' }}
            >
                <ExpandLess />
            </Fab>
        </Zoom>
    );
};

export default ScrollToTopButton;
